export class FiltroBusquedaCatalogo {
    Nombre: string;
    Valor: number;
}